import {
  Component,
  HostBinding,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import {
  cityResultMaskValidator,
  FormContainer,
  TypedFormControl,
  WarehouseMaskValidator,
} from '@shared';
import { StoreControls } from './store.enums';
import { STORE_TEST_ID } from './store.constants';
import { AddressTypes, CitySearchResult } from '@models';
import { StoreClasses, CityClasses } from '@core';

@Component({
  selector: 'app-store',
  templateUrl: 'store.component.html',
  styleUrls: ['./store.component.scss'],
})
export class StoreComponent
  extends FormContainer
  implements TypedFormControl, OnInit, OnDestroy
{
  type = AddressTypes.STORE;

  formGroup: UntypedFormGroup;

  @HostBinding('attr.data-test-id') testId = STORE_TEST_ID;

  @Input() controlName = 'StoreContainer';

  @Input() controlTypeName = 'type';

  @Input() isTemplate = false;

  @Input() cityClasses = CityClasses;

  @Input() warehouseClasses = StoreClasses;

  @Input() itemsFilterConfig = null;

  @Input() autofocus: boolean = true;

  cityRef: string = '';

  constructor(protected fb: UntypedFormBuilder) {
    super();
  }

  get cityValue(): CitySearchResult | string {
    return this.formGroup.get(StoreControls.city).value;
  }

  set cityValue(value: CitySearchResult | string) {
    this.formGroup.get(StoreControls.city).setValue(value);
  }

  get city(): AbstractControl | null {
    return this.formGroup.get(StoreControls.city);
  }

  get warehouse(): AbstractControl | null {
    return this.formGroup.get(StoreControls.store);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.form.removeControl(this.controlName);
  }

  loadWarehouses(cityRef: string): void {
    this.cityRef = cityRef;
  }

  addFormControls(): void {
    if (this.form) {
      this.createControl();
    }
  }

  createControl(): void {
    this.formGroup = this.fb.group({
      [StoreControls.city]: [
        '',
        [
          cityResultMaskValidator(),
          ...(this.isTemplate ? [] : [Validators.required]),
        ],
      ],
      [StoreControls.store]: [
        '',
        [Validators.required, WarehouseMaskValidator()],
      ],
    });
    this.form.setControl(this.controlName, this.formGroup);
    this.form.get(this.controlTypeName).setValue(this.type);
    this.warehouse.disable();
    this.initFormSubscriptions();
  }

  initFormSubscriptions(): void {
    this.subscriptions = this.city.statusChanges.subscribe((status) => {
      if (status === 'VALID' && this.city.value?.DeliveryCity) {
        this.warehouse.enable();
        this.loadWarehouses(this.city.value.DeliveryCity);
      } else {
        this.warehouse.disable();
        this.warehouse.reset('');
      }
    });
  }
}
